// files
import AdminSpaces from "../../Components/Admin/AdminSpaces"
const AdminSpacesPage = () => {
  return (
    <AdminSpaces />
  )
}
export default AdminSpacesPage